import React from "react";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";

const TIMEZONES = ["America/Lima", "America/Mexico_City", "America/Bogota", "America/Argentina/Buenos_Aires", "America/Sao_Paulo", "Europe/Madrid"];
const CURRENCIES = [{ value: "PEN", label: "PEN (Soles)" }, { value: "USD", label: "USD" }, { value: "MXN", label: "MXN" }, { value: "COP", label: "COP" }, { value: "ARS", label: "ARS" }, { value: "BRL", label: "BRL" }, { value: "EUR", label: "EUR" }];

export default function Step2BusinessData({ businessName, setBusinessName, timezone, setTimezone, currency, setCurrency }) {
  return (
    <>
      <Typography variant="h6" gutterBottom>Datos del negocio</Typography>
      <TextField fullWidth label="Nombre del negocio" value={businessName} onChange={(e) => setBusinessName(e.target.value)} margin="normal" />
      <TextField select fullWidth label="Zona horaria" value={timezone} onChange={(e) => setTimezone(e.target.value)} margin="normal">
        {TIMEZONES.map((z) => (<MenuItem key={z} value={z}>{z}</MenuItem>))}
      </TextField>
      <TextField select fullWidth label="Moneda" value={currency} onChange={(e) => setCurrency(e.target.value)} margin="normal">
        {CURRENCIES.map((c) => (<MenuItem key={c.value} value={c.value}>{c.label}</MenuItem>))}
      </TextField>
    </>
  );
}
